var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhostSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 214,
    viewBox: "0 0 160 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3645_4948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7083 194.625L12.0417 198.375C10.7083 199.417 9.08333 200 7.41667 200C3.33333 200 0 196.667 0 192.583V80C0 35.8333 35.8333 0 80 0C124.167 0 160 35.8333 160 80V192.583C160 196.667 156.667 200 152.583 200C150.917 200 149.292 199.417 147.958 198.375L143.292 194.625C137.708 190.167 129.625 190.875 124.917 196.25L112.208 210.833C110.833 212.417 108.792 213.333 106.667 213.333C104.542 213.333 102.542 212.417 101.125 210.833L90.0417 198.125C84.75 192.042 75.2917 192.042 69.9583 198.125L58.875 210.833C57.5 212.417 55.4583 213.333 53.3333 213.333C51.2083 213.333 49.2083 212.417 47.7917 210.833L35.0833 196.25C30.375 190.875 22.2917 190.167 16.7083 194.625ZM66.6667 80C66.6667 76.4638 65.2619 73.0724 62.7614 70.5719C60.2609 68.0714 56.8696 66.6667 53.3333 66.6667C49.7971 66.6667 46.4057 68.0714 43.9052 70.5719C41.4048 73.0724 40 76.4638 40 80C40 83.5362 41.4048 86.9276 43.9052 89.4281C46.4057 91.9286 49.7971 93.3333 53.3333 93.3333C56.8696 93.3333 60.2609 91.9286 62.7614 89.4281C65.2619 86.9276 66.6667 83.5362 66.6667 80ZM106.667 93.3333C110.203 93.3333 113.594 91.9286 116.095 89.4281C118.595 86.9276 120 83.5362 120 80C120 76.4638 118.595 73.0724 116.095 70.5719C113.594 68.0714 110.203 66.6667 106.667 66.6667C103.13 66.6667 99.7391 68.0714 97.2386 70.5719C94.7381 73.0724 93.3333 76.4638 93.3333 80C93.3333 83.5362 94.7381 86.9276 97.2386 89.4281C99.7391 91.9286 103.13 93.3333 106.667 93.3333Z",
    fill: "#DEE4E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3645_4948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 213.333,
    fill: "#DEE4E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostSolid);
export default __webpack_public_path__ + "static/media/ghost-solid.3d632cfc1086152625319935c45cd6f9.svg";
export { ForwardRef as ReactComponent };